import "./App.css";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthPage } from "./pages/auth/auth";
import { LoginForm } from "./pages/auth/login"
import { SignUpForm } from "./pages/auth/sign_up"
import { HomePage } from "./pages/home/home";
import { AppLayout } from "./pages/layout"
import { AuthLayout } from "./pages/auth_layout"
import { isMobile } from 'react-device-detect';
import { Contacts } from "./pages/contacts/contacts";
import { KnowledgeArticles } from "./pages/knowledge/knowledge_articles";
import { CreateRequest } from "./pages/requests/create_request";
import { MyRequest } from "./pages/requests/my_request";
import { Search } from "./pages/search/search";
import { Alert } from "react-bootstrap";
// lazy - can prob move this over to the sessionstore class but lazyrnow
const getToken = () => {
  const token = localStorage.getItem("token");
  return token && token !== "null" && token !== "undefined" ? token : null;
};

function RequireAuth({ children }) {
  return getToken() ? children : <Navigate to="/auth" replace />;
}

function PublicOnly({ children }) {
  return getToken() ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <div className="app">
      <ToastContainer position="top-center" autoClose={2000} />
      {/*If you want to allow this on desktop to you can remove*/}
      {isMobile ? (
        <Router>
          <Routes>
            {/* no auth */}
            <Route
              path="/auth"
              element={
                <PublicOnly>
                  <AuthLayout />
                </PublicOnly>
              }
            >
              <Route index element={<AuthPage />} />
              <Route path="login" element={<LoginForm />} />
              <Route path="signup" element={<SignUpForm />} />
            </Route>

            {/* auth */}
            <Route
              path="/"
              element={
                <RequireAuth>
                  <AppLayout />
                </RequireAuth>
              }
            >
              <Route index element={<HomePage />} />
              <Route path="contacts" element={<Contacts />} />
              <Route path="/knowledge_bases/" element={<p>Knowledge bases</p>} />
              <Route path="/articles/:kb_id" element={<KnowledgeArticles />} />
              <Route path="/request" element={<CreateRequest />} />
              <Route path="/my_request" element={<MyRequest />} />
              <Route path="/search" element={<Search />} />
            </Route>

            {/* fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      ) : (
          <Alert variant="danger">This site can only be accessed on a mobile device.</Alert>
      )}

    </div>
  );
}
